import { render, staticRenderFns } from "./DocumentSecureToolbar.vue?vue&type=template&id=3954b34f&scoped=true&"
import script from "./DocumentSecureToolbar.vue?vue&type=script&lang=js&"
export * from "./DocumentSecureToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSecureToolbar.vue?vue&type=style&index=0&id=3954b34f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954b34f",
  null
  
)

export default component.exports